module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-800-163d7a1b47ca2eed3a2267be13796e87.jpg";